// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__wNQ3b","tabs__nav":"Tabs_tabs__nav__8P_45","tabs__rail":"Tabs_tabs__rail__MK5yo","tabs__content":"Tabs_tabs__content__z_RYQ"};